/** German strings for main.ts (menu, garage, play, lobby, career; part A). Keys are the exact English source text. */
export const DE_MAIN_A: Readonly<Record<string, string>> = {
  // Finish banner
  'KNOCKED OUT': 'AUSGESCHIEDEN',
  'RUN COMPLETE': 'LAUF BEENDET',
  'VICTORY': 'SIEG',
  'FIRST OF {total}': 'ERSTER VON {total}',
  '+{gap} TO {name}': '+{gap} AUF {name}',
  'OF {total} DRIVERS': 'VON {total} FAHRERN',
  // Startup / PWA
  'NIGHTSHIFT installed': 'NIGHTSHIFT installiert',
  'A new build is ready for the next launch': 'Ein neues Update ist beim nächsten Start bereit',
  'Install prompt dismissed': 'Installation abgebrochen',
  'Offline checkpoint storage is temporarily unavailable; retrying in the background.': 'Offline-Speicherstand gerade nicht verfügbar – neuer Versuch im Hintergrund.',
  'This race link is missing its invite token.': 'Diesem Rennlink fehlt der Einladungscode.',
  'Unable to load the race.': 'Das Rennen konnte nicht geladen werden.',
  'INITIALISING RACE CONTROL': 'RENNLEITUNG WIRD GESTARTET',

  // Pause menu
  'PAUSED': 'PAUSE',
  'RACE MENU': 'RENNMENÜ',
  'POSITION': 'POSITION',

  // Wizard footer / steps
  'CHOOSE CAR': 'AUTO WÄHLEN',
  'TO THE GARAGE': 'ZUR GARAGE',
  'Enter ↵ continues': 'Enter ↵ weiter',
  'GARAGE · YOUR LOBBY IS WAITING': 'GARAGE · DEINE LOBBY WARTET',
  'STEP 3 OF 6 · YOUR MACHINE': 'SCHRITT 3 VON 6 · DEIN WAGEN',
  'LOBBY': 'LOBBY',
  'DRIVER': 'FAHRER',
  'GARAGE': 'GARAGE',
  'Garage': 'Garage',
  'BACK TO LOBBY': 'ZURÜCK ZUR LOBBY',
  'JOIN THE LOBBY': 'LOBBY BEITRETEN',
  'CHOOSE HOW TO PLAY': 'SPIELMODUS WÄHLEN',
  '← → browse cars · changes save automatically': '← → Autos durchblättern · Änderungen werden automatisch gespeichert',
  'Press G any time to open the garage': 'Drück jederzeit G für die Garage',
  'A friend': 'Ein Freund',
  'Private race': 'Privates Rennen',
  'Vehicle mastery paint equipped': 'Meisterschafts-Lackierung angelegt',

  // Play step / invites / lobby browser
  'That does not look like a NIGHTSHIFT invite link.': 'Das sieht nicht nach einem NIGHTSHIFT-Einladungslink aus.',
  'CLICK AGAIN TO DELETE EVERYTHING': 'NOCHMAL KLICKEN – ALLES LÖSCHEN',
  'RESET LOCAL DATA': 'LOKALE DATEN ZURÜCKSETZEN',
  'RESETTING…': 'WIRD ZURÜCKGESETZT…',
  'Lobby list unavailable — race control is not reachable.': 'Lobbyliste nicht verfügbar – Rennleitung nicht erreichbar.',
  'This invitation has expired or was revoked.': 'Diese Einladung ist abgelaufen oder wurde zurückgezogen.',
  'Race control is not reachable right now.': 'Die Rennleitung ist gerade nicht erreichbar.',
  'Invitation unavailable.': 'Einladung nicht verfügbar.',
  'OPENING LOBBY…': 'LOBBY WIRD ERÖFFNET…',
  'HOST A LOBBY': 'LOBBY HOSTEN',
  'Race control is not reachable. Try again, or race offline.': 'Rennleitung nicht erreichbar. Versuch es nochmal oder fahr offline.',
  'Unable to open a lobby.': 'Lobby konnte nicht eröffnet werden.',
  'JOINING…': 'TRITT BEI…',
  'The host has banned you from this lobby.': 'Der Host hat dich aus dieser Lobby verbannt.',
  'That race has already launched. Watch it live or pick another lobby.': 'Das Rennen läuft schon. Schau live zu oder such dir eine andere Lobby.',
  'That lobby is full.': 'Diese Lobby ist voll.',
  'Unable to join that lobby.': 'Beitritt zur Lobby fehlgeschlagen.',
  'Reconnecting to race control…': 'Verbinde neu mit der Rennleitung…',

  // Local launch card / in-lobby garage
  'OFFLINE': 'OFFLINE',
  'Offline race': 'Offline-Rennen',
  'LOW GRAVITY · {percent}% · LONGER JUMPS — STEER AND PITCH IN THE AIR': 'NIEDRIGE SCHWERKRAFT · {percent} % · WEITERE SPRÜNGE – IN DER LUFT LENKEN UND NEIGEN',
  'GRID RELEASED': 'STARTAUFSTELLUNG FREI',
  'BUILDING THE CIRCUIT…': 'STRECKE WIRD GEBAUT…',
  'TIP': 'TIPP',
  'Tap the handbrake to flick into a drift, then feather the throttle to hold it.': 'Tipp die Handbremse kurz an, um in den Drift zu kippen – dann hältst du ihn mit dosiertem Gas.',
  'Tuck in behind a rival: the slipstream builds your top speed.': 'Häng dich hinter einen Rivalen: Der Windschatten bringt dir Topspeed.',
  'Stuck against a wall? Reset puts you back on the racing line.': 'An der Wand hängen geblieben? Zurücksetzen bringt dich zurück auf die Ideallinie.',
  'Lift before the corner, not in it: the coach callouts tell you when.': 'Geh vor der Kurve vom Gas, nicht mittendrin – die Ansagen sagen dir, wann.',
  'Alternative routes can be faster. Watch the minimap for the split.': 'Alternativrouten können schneller sein. Achte auf der Minikarte auf die Abzweigung.',
  'Hits wear down your integrity. A wrecked car loses precious seconds.': 'Treffer kosten Integrität. Ein Wrack kostet dich wertvolle Sekunden.',
  'Switch the camera at any time to find the view that suits you.': 'Wechsle jederzeit die Kamera und finde die Ansicht, die dir liegt.',
  'BACK': 'ZURÜCK',
  'IN-LOBBY GARAGE': 'LOBBY-GARAGE',
  'Your rivals see the new car as soon as you apply it. Applying clears your ready state.': 'Deine Gegner sehen das neue Auto, sobald du es übernimmst. Dabei wird dein Bereit-Status zurückgesetzt.',
  'CANCEL': 'ABBRECHEN',
  'APPLY': 'ÜBERNEHMEN',

  // Offline lobby
  'That event track is not available in this build.': 'Diese Event-Strecke gibt es in dieser Version nicht.',
  'This event uses a fixed setup — press start when ready.': 'Dieses Event hat ein festes Setup – drück Start, wenn du bereit bist.',
  'The offline race could not start.': 'Das Offline-Rennen konnte nicht starten.',
  'The selected map is not available in the offline cache.': 'Die gewählte Strecke ist nicht im Offline-Speicher.',

  // Saved race card
  'Saved vehicle': 'Gespeichertes Fahrzeug',
  'GRID OPEN': 'GRID OFFEN',
  'STARTING': 'STARTET',
  'RACE IN PROGRESS': 'RENNEN LÄUFT',
  'OFFLINE CHECKPOINT': 'OFFLINE-SPEICHERSTAND',
  'LOCAL SAVE': 'LOKALER SPIELSTAND',
  'RESUME': 'FORTSETZEN',
  'SAVED RACE': 'GESPEICHERTES RENNEN',
  'Close': 'Schließen',
  'CONTINUE WITHOUT AN ACCOUNT': 'OHNE KONTO WEITERFAHREN',
  'Full race state stored on this device': 'Kompletter Rennstand auf diesem Gerät gespeichert',
  'Reconnect pass stored only in this browser': 'Wiedereinstiegs-Pass nur in diesem Browser gespeichert',
  'CONTINUE': 'WEITER',
  'Forget saved race': 'Gespeichertes Rennen verwerfen',
  'Local race removed. Your driver setup is still saved.': 'Lokales Rennen entfernt. Dein Fahrer-Setup bleibt gespeichert.',
  'That local race is no longer available.': 'Dieses lokale Rennen ist nicht mehr verfügbar.',
  'CHECKING…': 'PRÜFE…',
  'That race has already finished. Create a fresh one below.': 'Dieses Rennen ist schon vorbei. Starte unten ein neues.',
  'That race has ended or expired. Create a fresh one below.': 'Dieses Rennen ist beendet oder abgelaufen. Starte unten ein neues.',
  'Race control could not be reached. Your local save is safe—try again.': 'Rennleitung nicht erreichbar. Dein lokaler Spielstand ist sicher – versuch es nochmal.',
  'RESTORING…': 'WIRD WIEDERHERGESTELLT…',
  'Offline race restored from this device': 'Offline-Rennen von diesem Gerät wiederhergestellt',
  'Saved offline race could not be restored: {reason}': 'Gespeichertes Offline-Rennen konnte nicht wiederhergestellt werden: {reason}',
  'Saved offline race could not be restored.': 'Gespeichertes Offline-Rennen konnte nicht wiederhergestellt werden.',

  // Daily challenge
  'BEST {time}': 'BESTZEIT {time}',
  'FIRST RUN OPEN': 'ERSTER VERSUCH OFFEN',
  '{n} ATTEMPT': '{n} VERSUCH',
  '{n} ATTEMPTS': '{n} VERSUCHE',
  'Leave the current ghost challenge first': 'Verlass zuerst die aktuelle Ghost-Challenge',
  'RUN DAILY →': 'DAILY FAHREN →',
  'DAWN': 'MORGENGRAUEN',
  'DAY': 'TAG',
  'SUNSET': 'SONNENUNTERGANG',
  'NIGHT': 'NACHT',
  'CLEAR': 'KLAR',
  'HAZE': 'DUNST',
  'RAIN': 'REGEN',
  'SAND': 'SAND',
  'SNOW': 'SCHNEE',

  // Ghost challenge
  'Ghost challenge released // Its track is no longer available': 'Ghost-Challenge aufgehoben // Ihre Strecke ist nicht mehr verfügbar',
  'Ghost challenge released // Race setup unlocked': 'Ghost-Challenge aufgehoben // Renn-Setup freigeschaltet',
  'This ghost challenge link is damaged or uses an unavailable track': 'Dieser Ghost-Challenge-Link ist beschädigt oder nutzt eine nicht verfügbare Strecke',
  'Ghost challenge loaded // Beat {name}': 'Ghost-Challenge geladen // Schlag {name}',
  'Ghost loaded temporarily // Beat {name} · Browser storage unavailable': 'Ghost vorübergehend geladen // Schlag {name} · Browserspeicher nicht verfügbar',
  'GHOST CHALLENGE // {name}': 'GHOST-CHALLENGE // {name}',
  'LOCKED GHOST CHALLENGE': 'FESTE GHOST-CHALLENGE',
  'BEAT {name}': 'SCHLAG {name}',
  'RACE GHOST →': 'GEGEN GHOST FAHREN →',
  'Return to an unrestricted race setup': 'Zurück zu einem freien Renn-Setup',
  'LEAVE': 'VERLASSEN',
  'GHOST CHALLENGE': 'GHOST-CHALLENGE',
  'This ghost challenge is not available on this build.': 'Diese Ghost-Challenge gibt es in dieser Version nicht.',

  // Night tour
  '{tour} CLEARED': '{tour} GESCHAFFT',
  '{tour} // STAGE {stage}': '{tour} // ETAPPE {stage}',
  'Offline championships': 'Offline-Meisterschaften',
  'CLEARED': 'GESCHAFFT',
  'NEW': 'NEU',
  'OFFLINE-SAFE CHAMPIONSHIP': 'OFFLINE-MEISTERSCHAFT',
  'NIGHT TOUR // {tour}': 'NIGHT TOUR // {tour}',
  'TOUR COMPLETE': 'TOUR ABGESCHLOSSEN',
  'STAGE {stage} / {total}': 'ETAPPE {stage} / {total}',
  '{n} TOUR CLEARED · BEST {points} PTS': '{n} TOUR GESCHAFFT · BESTWERT {points} PKT',
  '{n} TOURS CLEARED · BEST {points} PTS': '{n} TOUREN GESCHAFFT · BESTWERT {points} PKT',
  '{reward} UNLOCKED.': '{reward} FREIGESCHALTET.',
  'YOU {player} · RIVAL BOSSES {rivals}': 'DU {player} · RIVALEN-BOSSE {rivals}',
  'Leave the ghost challenge before starting NIGHT TOUR': 'Verlass die Ghost-Challenge, bevor du die NIGHT TOUR startest',
  'NEW TOUR ↻': 'NEUE TOUR ↻',
  'CONTINUE TOUR →': 'TOUR FORTSETZEN →',
  'START TOUR →': 'TOUR STARTEN →',
  'Leave the ghost challenge before starting a surprise event': 'Verlass die Ghost-Challenge, bevor du ein Überraschungs-Event startest',
  'ONE-TAP QUICK EVENT': 'SCHNELL-EVENT MIT EINEM TIPP',
  'SURPRISE ME': 'ÜBERRASCH MICH',
  'RANDOM DISTRICT · MODE · CONDITIONS': 'ZUFÄLLIGES VIERTEL · MODUS · BEDINGUNGEN',
  'Unable to save the selected NIGHT TOUR.': 'Die gewählte NIGHT TOUR konnte nicht gespeichert werden.',
  'The next NIGHT TOUR district is unavailable in this build.': 'Das nächste NIGHT-TOUR-Viertel gibt es in dieser Version nicht.',
  'NIGHT TOUR // {tour} · STAGE {stage}': 'NIGHT TOUR // {tour} · ETAPPE {stage}',

  // Career
  'LV {level}': 'LV {level}',
  'LOCAL STREET CAREER': 'LOKALE STRASSENKARRIERE',
  '{races} RACES · {wins} WINS': '{races} RENNEN · {wins} SIEGE',
  'MAX RANK': 'MAX. RANG',
  '{done} / {total} STREET CONTRACTS': '{done} / {total} STRASSENAUFTRÄGE',
  'NEXT // {reward} · LV{level}': 'NÄCHSTE // {reward} · LV{level}',
  'ALL RANK REWARDS UNLOCKED': 'ALLE RANGBELOHNUNGEN FREIGESCHALTET',
  'Rotating career contracts': 'Wechselnde Karriereaufträge',
  'LIVE CONTRACTS': 'LIVE-AUFTRÄGE',
  'OFFLINE-SAFE · AUTO ROTATION': 'OFFLINE-SICHER · AUTO-WECHSEL',
  'CLAIMED': 'EINGELÖST',
  'REWARD PAINT': 'BELOHNUNGSLACK',
  'Apply {paint} paint': 'Lackierung {paint} anwenden',
  '{paint} paint unlocks at level {level}': 'Lackierung {paint} wird ab Level {level} freigeschaltet',
  'Apply City Lights tour paint': 'Tour-Lackierung City Lights anwenden',
  'City Lights paint unlocks by completing its tour': 'Lackierung City Lights: schließ ihre Tour ab',
  'Apply Summit Ice tour paint': 'Tour-Lackierung Summit Ice anwenden',
  'Summit Ice paint unlocks by completing Mountain Pulse': 'Lackierung Summit Ice: schließ Mountain Pulse ab',
  'Apply Outlaw Frequency tour paint': 'Tour-Lackierung Outlaw Frequency anwenden',
  'Outlaw Frequency paint unlocks by completing its tour': 'Lackierung Outlaw Frequency: schließ ihre Tour ab',
  'Apply Nemesis Violet paint': 'Lackierung Nemesis Violet anwenden',
  'Nemesis Violet unlocks after beating one rival three times': 'Nemesis Violet: schlag einen Rivalen dreimal',
  'RANK PAINTS · THREE TOUR PAINTS · NEMESIS VIOLET AT 3 WINS': 'RANGLACKE · DREI TOUR-LACKE · NEMESIS VIOLET BEI 3 SIEGEN',

  // Nemesis
  'CURRENT NEMESIS': 'AKTUELLE NEMESIS',
  'YOU LEAD': 'DU FÜHRST',
  '{n} DOWN': '{n} HINTEN',
  '{n} LOSS STREAK': '{n} NIEDERLAGEN IN FOLGE',
  '{n} WIN STREAK': '{n} SIEGE IN FOLGE',
  'Leave the ghost challenge before starting a revenge race': 'Verlass die Ghost-Challenge, bevor du ein Revanche-Rennen startest',
  'REVENGE →': 'REVANCHE →',
  'NEMESIS REVENGE': 'NEMESIS-REVANCHE',
  '{name} IS WAITING': '{name} WARTET',

  // Car info / tuning
  'ACTIVE MASTERY SIGNATURE': 'AKTIVE MEISTER-SIGNATUR',
  'SIGNATURE PREVIEW': 'SIGNATUR-VORSCHAU',
  'Its event-triggered sidegrade is equipped automatically.': 'Ihr ereignisgesteuerter Sidegrade wird automatisch ausgerüstet.',
  'Complete all mastery goals to activate its gameplay sidegrade.': 'Schließ alle Meisterschaftsziele ab, um ihren Sidegrade zu aktivieren.',
  'VEHICLE MASTERY': 'FAHRZEUG-MEISTERSCHAFT',
  'MASTERY PAINT EQUIPPED': 'MEISTER-LACK AKTIV',
  'EQUIP MASTERY PAINT': 'MEISTER-LACK ANLEGEN',
  'PAINT LOCKED': 'LACK GESPERRT',
  'TOP SPEED': 'TOPSPEED',
  'ACCEL': 'BESCHL.',
  'HANDLING': 'HANDLING',
  'TERRAIN': 'GELÄNDE',
  'CREW MODULE // ONE TRADE-OFF': 'CREW-MODUL // EIN KOMPROMISS',
  'Leave the ghost challenge to change its performance setup.': 'Verlass die Ghost-Challenge, um ihr Leistungs-Setup zu ändern.',

  // Quick events / daily / errors
  'No quick-event district is available.': 'Kein Viertel für ein Schnell-Event verfügbar.',
  'QUICK EVENT': 'SCHNELL-EVENT',
  'Today’s challenge is not available in this cache.': 'Die heutige Challenge ist nicht im Speicher.',
  'DAILY // {id}': 'DAILY // {id}',
  '{car} TIME ATTACK': '{car} ZEITFAHREN',

  // Connection
  'The host removed you from the lobby': 'Der Host hat dich aus der Lobby entfernt',
  'The saved race has expired or its reconnect pass is no longer valid.': 'Das gespeicherte Rennen ist abgelaufen oder sein Wiedereinstiegs-Pass ist ungültig.',
  'The offline simulation stopped: {reason}': 'Die Offline-Simulation wurde gestoppt: {reason}',
  'The race client could not process live data: {reason}': 'Der Renn-Client konnte die Live-Daten nicht verarbeiten: {reason}',
};
